import { settings } from './cart-utils';

export class Cart {
  constructor() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.getCart = this.getCart.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.updateCartTriggerState = this.updateCartTriggerState.bind(this);
    this.add = this.add.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.build = this.build.bind(this);
    this.buildVariantOptionsWithValues = this.buildVariantOptionsWithValues.bind(this);
    this.buildVariantTitle = this.buildVariantTitle.bind(this);
    this.buildVariantProperties = this.buildVariantProperties.bind(this);
    this.optimizeImageUrl = this.optimizeImageUrl.bind(this);
    this.hasItems = this.hasItems.bind(this);
    this.getItemsCount = this.getItemsCount.bind(this);
    this.toggle = this.toggle.bind(this);
    this.appendCartHtml = this.appendCartHtml.bind(this);
    this.buildItem = this.buildItem.bind(this);
    this.buildItemsCount = this.buildItemsCount.bind(this);
    this.buildItemsHtml = this.buildItemsHtml.bind(this);
    this.buildCartSavings = this.buildCartSavings.bind(this);
    this.initCartDrawer = this.initCartDrawer.bind(this);
    this.buildCart = this.buildCart.bind(this);
    this.settings = settings;
    this.isCartBuilded = false;
    this.isCartDrawerOpen = false;

    $(document).on(
      'click',
      this.settings.selectors.cartToggleTrigger,
      $.proxy(function(event) {
        event.preventDefault();

        this.toggle();
      }, this)
    );

    $(document).on('click', function(event) {
      const $target = $(event.target);

      if (!$target.closest('#cart-drawer').length && !$target.hasClass('js-cart-toggle-trigger')) {
        $('#cart-drawer').removeClass('is-visible');
        $('body').removeClass('is-drawer-open no-scroll');
        $('.js-header').removeClass('is-white');
      }
    })
  }

  /**
   * Get the cart and build it
   * @return {Void}
   */

  getCart() {
    $.ajax({
      url: '/cart?view=json',
      context: this,
      type: 'GET',
      // Issue when dataType is used; missing json properties
      // Use JSON parse instead.
      // dataType: 'json',
      success(cart) {
        const parsed = JSON.parse(cart);
        this.build(parsed);
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Add item(s) to the cart and build it
   * @param {Array} items - An array holding the object(s) with item properties.
   *                      - More info: https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   * @return {Void}
   */

  add(items) {
    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { items },
      success(item) {
        this.getCart();
        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);
      },
      error(err) {
        alert(err.responseJSON.description);
        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);
      },
    });
  }

  /**
   * Update/Remove item from the cart
   * @param  {Integer} quantity - Quantity of the updated item. 0 for item removal.
   * @param  {Integer} id - The KEY of the line item.
   * @param  {Object}  properties - Properties of the line item.
   * @param  {isCartPage}  isCartPage - Use it to build the cart page or the cart drawer.
   * @return {Void}
   */

  updateItem(quantity, id, properties = {}, isCartPage = false) {
    $.ajax({
      url: '/cart/change.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { quantity, id, properties },
      success(cart) {
        $.ajax({
          url: '/cart?view=json',
          context: this,
          type: 'GET',
          // Issue when dataType is used; missing json properties
          // Use JSON parse instead.
          // dataType: 'json',
          success(cart) {
            const parsed = JSON.parse(cart);
            this.build(parsed, isCartPage);
          },
          error(err) {
            alert(err.responseJSON.description);
          },
        });
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Build item variant options with values, if available
   * @param  {Object} item - The item JSON
   * @return {String}
   */

  buildVariantOptionsWithValues(item) {
    const hasVariants = item.options_with_values.length && item.options_with_values[0].value !== 'Default Title';
    let variantsHtml = '';

    if (hasVariants) {
      item.options_with_values.forEach((option) => {
        let template = this.settings.templates.cartDrawerItemVariants;
        let optionName = option.name;

        if (option.name === 'Color' || option.name === 'Colour') {
          optionName = Shopify.theme.locale.products.product.swatches_label;
        }

        template = template.replace(/{{optionName}}/g, optionName);
        template = template.replace(/{{optionValue}}/g, option.value);

        variantsHtml += template;
      });
    }

    return variantsHtml;
  }

  /**
   * Build variant title, based on options
   * @param  {Object} item - The item JSON
   * @return {String}
   */

  buildVariantTitle(item) {
    const hasVariants = item.options_with_values.length && item.options_with_values[0].value !== 'Default Title';
    let variantsHtml = '';
    let optionsHtml = '';

    if (hasVariants) {
      variantsHtml = this.settings.templates.cartPageItemVariants;

      item.options_with_values.forEach((option) => {
        let optionName = option.name;

        if (optionName === 'Color' || optionName === 'Colour') {
          optionName = Shopify.theme.locale.products.product.swatches_label;
        }

        optionsHtml += `<li class="product-details__item product-details__item--variant-option" data-cart-item-option>${optionName}: ${option.value}</li>`;
      });
    }

    variantsHtml = variantsHtml.replace(/{{itemVariantOptions}}/g, optionsHtml);

    return variantsHtml;
  }

  /**
   * Build item properties, if available
   * @param  {Object} item - The item
   * @param  {String} template - The item template
   * @return {String}
   */

  buildVariantProperties(item, template) {
    const hasProperties = item.properties !== null && item.properties !== {};
    let propertiesHtml = '';

    if (hasProperties) {
      Object.keys(item.properties).forEach((key) => {
        let html = template;

        html = html.replace(/{{propertyKey}}/g, key);
        html = html.replace(
          /{{propertyKeyValue}}/g,
          item.properties[key].indexOf('/uploads/') !== -1
            ? `<a href="${item.properties[key]}">${item.properties[key].split('/uploads/')[1]}</a>`
            : item.properties[key]
        );
        propertiesHtml += html;
      });
    }

    return propertiesHtml;
  }

  /**
   * Build cart/cart drawer
   * @param  {Object}  cart       - The cart JSON
   * @param  {Boolean} isCartPage - Determines what to build - Cart drawer or cart page
   * @return {Void}
   */

  build(cart, isCartPage = false) {
    this.updateCounter(this.getItemsCount(cart));
    this.updateCartTriggerState(this.getItemsCount(cart));

    if (!this.hasItems(cart)) {
      const template = isCartPage ? this.settings.templates.cartPageItemsHolderEmpty : this.settings.templates.cartDrawerEmpty;

      this.buildCart(cart, template, isCartPage);

      return;
    }

    const template = isCartPage ? this.settings.templates.cartPageItemsHolder : this.settings.templates.cartDrawer;
    const itemsHtml = this.buildItemsHtml(cart.items, isCartPage);

    this.buildCart(cart, template, isCartPage, itemsHtml);
  }

  /**
   * Build cart elements
   * @param  {Object}  cart       - The JSON of the cart
   * @param  {String}  html       - The cart template
   * @param  {Boolean} isCartPage
   * @param  {String}  itemsHtml  - Items HTML
   * @return {Void}
   */

  buildCart(cart, template, isCartPage = false, itemsHtml = '') {
    const $holder = isCartPage ? $(this.settings.selectors.cartHolder) : $(this.settings.selectors.cartDrawer);

    if (itemsHtml !== '') {
      template = template.replace(/{{itemsCount}}/g, this.buildItemsCount(cart));
      template = template.replace(/{{cartItems}}/g, itemsHtml);
      template = template.replace(/{{cartTotalPrice}}/g, Shopify.formatMoney(cart.total_price, Shopify.current_money_format));
      template = template.replace(/{{cartSubTotalPrice}}/g, Shopify.formatMoney(cart.items_subtotal_price, Shopify.current_money_format));
      template = template.replace(/{{cartSavings}}/g, this.buildCartSavings(cart));
    }

    this.appendCartHtml($holder, template);
    !isCartPage && this.initCartDrawer(cart);
  }

  /**
   * Build cart items count
   * @param  {Object} cart - The cart JSON
   * @return {String}
   */

  buildItemsCount(cart) {
    let count = '';

    if (cart.item_count > 0) count = `(${cart.item_count})`

    return count;
  }

  /**
   * Build cart savings
   * @param  {Object} cart - The cart JSON
   * @return {String}
   */

  buildCartSavings(cart) {
    let html = '';

    if (cart.total_saved > 0) {
      const text = Shopify.theme.locale.cart.general.saved;
      const amount = Shopify.formatMoney(cart.total_saved, Shopify.current_money_format)

      html += `
        <li class="js-cart-save">
          <h5>${text}</h5>

          <span class="price money">-${amount}</span>
        </li>
      `
    }

    return html;
  }

  /**
   * Build cart item
   * @param  {Object}  item           - The cart item
   * @param  {Integer}  index          - Index of the cart item
   * @param  {Boolean} isCartPageItem - Is it item from the cart page
   * @return {String}                 - The item HTML
   */

  buildItem(item, index, isCartPageItem) {
    let template = isCartPageItem ? this.settings.templates.cartPageItem : this.settings.templates.cartDrawerItem;
    const itemImageSize = isCartPageItem ? this.settings.cartPage.itemImageSize : this.settings.cartDrawer.itemImageSize;
    const propertiesTemplate = isCartPageItem
      ? this.settings.templates.cartPageItemProperties
      : this.settings.templates.cartDrawerItemProperties;

    template = template.replace(
      /{{itemImageUrl}}/g,
      this.optimizeImageUrl(item.featured_image.url !== null ? item.featured_image.url : this.settings.noImage, itemImageSize)
    );
    template = template.replace(/{{itemUrl}}/g, item.url);
    template = template.replace(/{{itemTitle}}/g, item.product_title);

    if (!isCartPageItem) {
      template = template.replace(/{{itemVariants}}/g, this.buildVariantOptionsWithValues(item));
    } else {
      template = template.replace(/{{itemVariants}}/g, this.buildVariantTitle(item));
    }

    // Calculate compared price
    let itemComparedPrice = '';
    if (item.compare_at_price) {
      itemComparedPrice = Shopify.formatMoney(item.compare_at_price, Shopify.current_money_format)
    }

    template = template.replace(/{{itemProperties}}/g, this.buildVariantProperties(item, propertiesTemplate));
    template = template.replace(/{{itemLinePrice}}/g, Shopify.formatMoney(item.line_price, Shopify.current_money_format));
    template = template.replace(/{{itemPrice}}/g, Shopify.formatMoney(item.price, Shopify.current_money_format));
    template = template.replace(/{{itemComparedPrice}}/g, itemComparedPrice);
    template = template.replace(/{{itemIndex}}/g, index + 1);
    template = template.replace(/{{itemKey}}/g, item.key);
    template = template.replace(/{{itemId}}/g, item.id);
    template = template.replace(/{{itemQuantity}}/g, item.quantity);

    return template;
  }

  /**
   * Build items HTML
   * @param  {Array}  items      - The items array
   * @param  {Boolean} isCartPage
   * @return {String}             - The items HTML
   */

  buildItemsHtml(items, isCartPage) {
    let html = '';

    items.forEach((item, index) => {
      html += this.buildItem(item, index, isCartPage);
    });

    return html;
  }

  /**
   * Append items content to holder
   * @param  {jQuery Object} $holder - The holder to append items html to.
   * @param  {String} html - The items html.
   * @return {Void}
   */

  appendCartHtml($holder, html) {
    $holder[0].innerHTML = '';
    $holder[0].innerHTML = html;
  }

  /**
   * Opens the cart drawer
   * @return {void}
   */

  open() {
    if (this.isCartBuilded) {
      $(this.settings.selectors.body).addClass(this.settings.actionClasses.bodyClasses);
      $(this.settings.selectors.cartDrawer).addClass(this.settings.actionClasses.visible);
      $(this.settings.selectors.header).addClass(this.settings.actionClasses.white);
    } else {
      this.getCart();
    }
  }

  /**
   * Closes the cart drawer
   * @return {void}
   */

  close() {
    $(this.settings.selectors.body).removeClass(this.settings.actionClasses.bodyClasses);
    $(this.settings.selectors.cartDrawer).removeClass(this.settings.actionClasses.visible);
    $(this.settings.selectors.header).removeClass(this.settings.actionClasses.white);
  }

  /**
   * Toggle cart drawer
   * @return {Void}
   */

  toggle() {
    this.isCartDrawerOpen = !this.isCartDrawerOpen;
    this.isCartDrawerOpen ? this.open() : this.close();
  }

  /**
   * Initialize the cart drawer upon build
   * @param  {Object} cart - The cart JSON
   * @return {Void}
   */

  initCartDrawer(cart) {
    $(this.settings.selectors.cartDrawer).toggleClass(this.settings.actionClasses.empty, !this.hasItems(cart));

    this.isCartBuilded = true;

    this.open();
  }

  /**
   * Update cart items counters
   * @param  {Integer} itemsCount - Items count
   * @return {Void}
   */

  updateCounter(itemsCount) {
    $(this.settings.selectors.cartCount)
      .toggleClass(this.settings.actionClasses.hidden, !itemsCount)
      .text(`(${itemsCount})`);
  }

  /**
   * Update the cart trigger state - has or has not items class
   * @param  {Integer} itemsCount - Cart items count
   * @return {Void}
   */

  updateCartTriggerState(itemsCount) {
    $(this.settings.selectors.cartTrigger).toggleClass(this.settings.actionClasses.hasItems, itemsCount > 0);
  }

  /**
   * Optimize image based on parameter
   * @param  {String} url       - Image url
   * @param  {String} parameter - Size of the image, for example: '_200x200'
   * @return {String}           - Optimized image URL
   */

  optimizeImageUrl(url, parameter) {
    if (!url) return;

    let imageUrl = url;
    let lastDotIndex = imageUrl.lastIndexOf('.');
    imageUrl = `${imageUrl.substring(0, lastDotIndex)}_${parameter}.${imageUrl.substring(lastDotIndex + 1)}`;

    return imageUrl;
  }

  /**
   * Get cart items count
   * @param  {Object}  cart - JSON of the cart
   * @return {Boolean}      - Is cart has items
   */

  hasItems(cart) {
    return cart.item_count ? true : false;
  }

  /**
   * Get the cart items count
   * @param  {Object} cart - JSON of the cart
   * @return {Integer}     - Cart items count
   */

  getItemsCount(cart) {
    return cart.item_count;
  }
}

/**
 * Assign the Cart class to the window object for global use
 */

window.Cart = new Cart();
